import { api } from '@/api'
import { GetAnalyticsResponse } from '@/store/analytic.types'

export const analyticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDailyAnalytics: builder.query<GetAnalyticsResponse, { dateStart: string }>({
      query: ({ dateStart }) => ({
        url: '/query/analytics/day',
        method: 'GET',
        params: { dateStart },
      }),
    }),
    getWeeklyAnalytics: builder.query<GetAnalyticsResponse, { dateStart: string }>({
      query: ({ dateStart }) => ({
        url: '/query/analytics/week',
        method: 'GET',
        params: { dateStart },
      }),
    }),
    getMonthlyAnalytics: builder.query<GetAnalyticsResponse, { dateStart: string }>({
      query: ({ dateStart }) => ({
        url: '/query/analytics/month',
        method: 'GET',
        params: { dateStart },
      }),
    }),
    getYearlyAnalytics: builder.query<GetAnalyticsResponse, { dateStart: string }>({
      query: ({ dateStart }) => ({
        url: '/query/analytics/year',
        method: 'GET',
        params: { dateStart },
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetDailyAnalyticsQuery,
  useGetWeeklyAnalyticsQuery,
  useGetMonthlyAnalyticsQuery,
  useGetYearlyAnalyticsQuery,
} = analyticsApi
